export default __webpack_public_path__ + "static/media/ai_conversation_icon.f01cdfa2.svg";